import styled from 'styled-components';

export const CardStyleds = styled.div`
  margin: ${props => props.theme.spacing.sm};
  padding: ${props => props.theme.spacing.md};
  border-radius: ${props => props.theme.radii.md};
  border: 1px solid ${props => props.theme.colors.border};
  background: ${props => props.theme.colors.surface};
  box-shadow: ${props => props.theme.shadows.xs};
`;
